// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__3qgB8","noInteraction":"EventWrapper_noInteraction__382V4"};